import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=8e0bbc2a&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=8e0bbc2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0bbc2a",
  null
  
)

export default component.exports